import theme from "@/theme";

export const stylesTrendingUser = {
  wrapperTrendingUsers: {
    display: "flex",
    gap: "14px",
    flexDirection: "column",
    width: "100%",
    padding: "12px 20px 12px 16px",
    borderRadius: "15px",
    backgroundColor: "#F7F9FB",
  },
  headerTrendingUsers: {
    display: "flex",
    flexDirection: "row",
    width: "304px",
    height: "36px",
    opacity: 1,
    gap: "26px",
  },
  selectBox: {
    display: "flex",
    gap: 1,
    margin: "1.5rem 0 1.375rem 0",
  },
  select: {
    flex: 1,
    borderRadius: "8px",
    bgcolor: "#F7F9FB",
    color: theme.palette.custom.blueGray500,
    border: "none",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiSelect-select": {
      svg: {
        display: "none",
      },
    },
  },
  tableContainer: {
    borderRadius: "0.5rem",
    overflowX: "hidden",
  },
  tableWrapper: {
    overflowX: "hidden",
  },
  tableBody: {
    "& .MuiTableRow-root": {
      width: "272px",
      paddingTop: "8px",
      paddingBottom: "8px",
      "&:last-child": {
        borderBottom: "none",
      },
    },
    "& .MuiTableCell-root": {
      padding: "0.5rem 0.75rem",
      borderBottom: "none",
    },
  },

  tableRow: {
    height: "52px",
    cursor: "pointer",
  },
  usernameRow: {
    display: "flex",
    gap: "0.4375rem",
    alignItems: "center",
  },
  tableCellw: {
    padding: "0 !important",
  },
  userName: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "17px",
    letterSpacing: "0%",
    color: "#202327",
  },
  userLikes: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "15px",
    letterSpacing: "0%",

    color: "#6E767D",
  },
  likesCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "0.25rem",
  },
  likesText: {
    fontWeight: 400,
    marginLeft: "0.25rem",
  },
  positionCell: {
    "& .MuiTypography-root": {
      fontWeight: 500,
    },
  },
};
